import { computed, onBeforeMount, readonly } from 'vue';
import store from '@/store';
import { getFonts, getFontUploadSignedUrl, validateFont } from '@/api/fonts';
import { uploadFileToS3 } from '@/utils/s3Utils';
import { useLoader } from './loader';

export interface UserFont {
    Name: string;
    Path: string;
    Style: string;
    User_Id: number;
}

export const useFonts = (initialFetch?: boolean) => {
    const { updateText } = useLoader();

    onBeforeMount(() => {
        if (initialFetch && !userFonts.value.length) {
            refreshUserFonts();
        }
    });

    const userFonts = computed<UserFont[]>(() => store.state.userFonts);

    const setFonts = (fonts: UserFont[]) => {
        store.commit('userFonts', fonts);
    };

    const refreshUserFonts = async () => {
        const fonts = await getFonts();
        setFonts(fonts);
    };

    const uploadUserFont = async (file: File): Promise<string> => {
        const url = await getFontUploadSignedUrl(file.name);
        await uploadFileToS3(url.SignedUrl, url.Mime, file, undefined, (progress) => {
            updateText(`Uploading font ${progress}%`);
        });
        await validateFont(url.Name);
        return url.Name;
    };

    const generateFontName = (font: UserFont): string => `${font.Name} (${font.Style})`;

    const getFontFromPath = (path: string): UserFont | undefined => userFonts.value.find((font) => font.Path == path);

    return {
        userFonts: readonly(userFonts),
        refreshUserFonts,
        setFonts,
        uploadUserFont,
        generateFontName,
        getFontFromPath
    };
};
